export { default } from './PostsListView';



// WEBPACK FOOTER //
// ./src/components/PostsListView/index.js